import React from 'react';
import { mdiAlertCircleOutline } from '@mdi/js';
import Icons from '../Icon';
import './styles.css';

export const NoticeBox = ({ title, children, icon, className = '' }) => {
  return (
    <div className={`notice-box ${className}`}>
      <div className="notice-box__icon">
        <Icons
          path={icon || mdiAlertCircleOutline}
          size={1.5}
          color="var(--primary-color)"
        />
      </div>
      <div className="notice-box__content">
        {title && <span className="notice-box__title">{title}</span>}
        <div className="notice-box__text">{children}</div>
      </div>
    </div>
  );
};
